import React from "react";
import PropTypes from "prop-types";
import StyledDropDownRadio from "./DropDownRadio.styled";

const DropDownRadio = React.memo(props => {
  const { range, checked, value,name, getId, onChange } = props;
  return (
    <StyledDropDownRadio className={`dropdown-sort__radio ${checked && "is-checked"}`}>
      <svg className="dropdown-sort__radio__svg-left" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke="null" d="m23.96975,0.04124l-16.49031,0l0,2.89404l-0.28414,0l0.28414,0.34173l0,4.6027l-2.27313,0l0,4.36776l-2.85155,0l0,3.60954l-2.28327,0l0,5.42499l2.02958,0l0,3.01151l10.5132,0l0,-0.29902l11.35548,0"/></svg>

      <input  checked={checked} value={value} onChange={onChange} onClick={(e) => getId(e)} aria-label={name} id={range.id}   type="radio" />
      <span className="dropdown-sort__radio__custom"/>
      <span className="t-body-small dropdown-sort__radio__copy">{range.name}</span>

      <svg className="dropdown-sort__radio__svg-right" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke="null" d="m-0.12938,23.95877l18.06,0l0,-10.39136l4.12,0l0,-4.05412l1.93,0l0,-9.48452l-6.05,0l-17.9,0"/></svg>
    </StyledDropDownRadio>
  );
});

DropDownRadio.propTypes = {
  range: PropTypes.object.isRequired,
  checked: PropTypes.bool.isRequired
};

export default DropDownRadio;